import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Urunler() {
  const navigate = useNavigate();
  const [urunler, setUrunler] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [arama, setArama] = useState('');
  const [filtreFirma, setFiltreFirma] = useState('');
  const [filtreGrup, setFiltreGrup] = useState('');

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    const [{ data: u }, { data: f }] = await Promise.all([
      supabase.from('urunler').select('*, firmalar(ad)').order('sira', { ascending: true }).order('ad'),
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
    ]);
    setUrunler(u || []);
    setFirmalar(f || []);
    setLoading(false);
  }

  async function toggleAktif(u) {
    await supabase.from('urunler').update({ aktif: !u.aktif }).eq('id', u.id);
    fetchData();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu ürünü silmek istediğinizden emin misiniz?')) return;
    await supabase.from('urunler').delete().eq('id', id);
    fetchData();
  }

  async function handleGrupPasif(grupAdi) {
    const grupUrunleri = urunler.filter(u => (u.alt_grup || 'Diğer').trim() === grupAdi);
    if (!window.confirm(`"${grupAdi}" grubundaki ${grupUrunleri.length} ürün pasife alınacak. Geçmiş satış verileri korunacak. Emin misiniz?`)) return;
    await Promise.all(grupUrunleri.map(u => supabase.from('urunler').update({ aktif: false }).eq('id', u.id)));
    fetchData();
  }

  async function sirayiDegistir(urun, yon) {
    const grupAdi = (urun.alt_grup || 'Diğer').trim();
    const grupUrunleri = urunler
      .filter(u => (u.alt_grup || 'Diğer').trim() === grupAdi)
      .sort((a, b) => (a.sira || 0) - (b.sira || 0) || a.ad.localeCompare(b.ad, 'tr'));
    const idx = grupUrunleri.findIndex(u => u.id === urun.id);
    const hedefIdx = yon === 'yukari' ? idx - 1 : idx + 1;
    if (hedefIdx < 0 || hedefIdx >= grupUrunleri.length) return;
    const hedef = grupUrunleri[hedefIdx];
    const mySira = urun.sira || 0;
    const hedefSira = hedef.sira || 0;
    await Promise.all([
      supabase.from('urunler').update({ sira: hedefSira }).eq('id', urun.id),
      supabase.from('urunler').update({ sira: mySira }).eq('id', hedef.id),
    ]);
    fetchData();
  }

  const altGruplar = [...new Set(
    urunler
      .filter(u => !filtreFirma || u.firma_id === filtreFirma)
      .map(u => (u.alt_grup || '').trim())
      .filter(Boolean)
  )].sort();

  const filtreli = urunler.filter(u => {
    if (arama && !u.ad.toLowerCase().includes(arama.toLowerCase()) &&
      !(u.alt_grup || '').toLowerCase().includes(arama.toLowerCase())) return false;
    if (filtreFirma && u.firma_id !== filtreFirma) return false;
    if (filtreGrup && (u.alt_grup || '').trim() !== filtreGrup) return false;
    return true;
  });

  const grupSirasi = [...new Set(filtreli.map(u => (u.alt_grup || 'Diğer').trim()))].sort();

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Ürünler</h1>
          <p className="page-subtitle">{filtreli.length} ürün gösteriliyor</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/urunler/yeni')}>+ Yeni Ürün</button>
      </div>

      <div className="filter-bar">
        <input className="input" placeholder="Ürün adı ara..." value={arama} onChange={e => setArama(e.target.value)} />
        <select className="select" value={filtreFirma} onChange={e => setFiltreFirma(e.target.value)}>
          <option value="">Tüm Firmalar</option>
          {firmalar.map(f => <option key={f.id} value={f.id}>{f.ad}</option>)}
        </select>
        <select className="select" value={filtreGrup} onChange={e => setFiltreGrup(e.target.value)}>
          <option value="">Tüm Alt Gruplar</option>
          {altGruplar.map(g => <option key={g} value={g}>{g}</option>)}
        </select>
        <button className="btn btn-ghost btn-sm" onClick={() => { setArama(''); setFiltreFirma(''); setFiltreGrup(''); }}>Temizle</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Sıra</th><th>Ürün Adı</th><th>Firma</th><th>Alt Grup</th>
              <th>Banka (KDVsiz)</th><th>K.K.</th><th>Maliyet</th>
              <th>Kom. %</th><th>Durum</th><th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={10} className="loading">Yükleniyor...</td></tr>
            ) : filtreli.length === 0 ? (
              <tr><td colSpan={10} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Ürün bulunamadı</td></tr>
            ) : grupSirasi.map(grupAdi => {
              const grupUrunleri = filtreli
                .filter(u => (u.alt_grup || 'Diğer').trim() === grupAdi)
                .sort((a, b) => (a.sira || 0) - (b.sira || 0) || a.ad.localeCompare(b.ad, 'tr'));
              return [
                <tr key={'g-' + grupAdi}>
                  <td colSpan={10} style={{
                    background: 'var(--bg3)', padding: '8px 16px', fontWeight: 700,
                    fontSize: 12, color: 'var(--accent)', letterSpacing: 1,
                    textTransform: 'uppercase', borderTop: '2px solid var(--border)',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  }}>
                    <span>📂 {grupAdi}</span>
                    <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, padding: '2px 8px', textTransform: 'none', color: 'var(--red)' }} onClick={() => handleGrupPasif(grupAdi)}>Grubu Pasife Al</button>
                  </td>
                </tr>,
                ...grupUrunleri.map((u, gi) => (
                  <tr key={u.id}>
                    <td>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <button className="btn btn-ghost btn-sm" style={{ padding: '2px 6px', fontSize: 11 }}
                          onClick={() => sirayiDegistir(u, 'yukari')} disabled={gi === 0}>▲</button>
                        <button className="btn btn-ghost btn-sm" style={{ padding: '2px 6px', fontSize: 11 }}
                          onClick={() => sirayiDegistir(u, 'asagi')} disabled={gi === grupUrunleri.length - 1}>▼</button>
                      </div>
                    </td>
                    <td style={{ fontWeight: 500 }}>{u.ad}</td>
                    <td style={{ color: 'var(--text2)' }}>{u.firmalar?.ad}</td>
                    <td style={{ color: 'var(--text2)', fontSize: 12 }}>{u.alt_grup || '-'}</td>
                    <td style={{ color: 'var(--green)', fontSize: 12 }}>
                      {(u.banka_fiyat_kdvsiz || 0).toLocaleString('tr-TR')} ₺
                      {u.hya_banka_fiyat > 0 && <span style={{ color: 'var(--text2)' }}> / {(u.hya_banka_fiyat || 0).toLocaleString('tr-TR')} ₺</span>}
                    </td>
                    <td style={{ color: 'var(--yellow)' }}>{((u.kk_fiyat_kdvli || u.kk_fiyat_kdvsiz || 0)).toLocaleString('tr-TR')} ₺</td>
                    <td style={{ color: 'var(--text2)' }}>{(u.maliyet || 0).toLocaleString('tr-TR')} ₺</td>
                    <td>
                      {u.komisyonsuz
                        ? <span className="badge badge-gray">Komisyonsuz</span>
                        : <span>%{u.bireysel_komisyon || 0} / %{u.kurumsal_komisyon || 0}</span>}
                    </td>
                    <td>
                      <span onClick={() => toggleAktif(u)}
                        className={`badge ${u.aktif ? 'badge-green' : 'badge-red'}`}
                        style={{ cursor: 'pointer' }}>
                        {u.aktif ? '✓ Aktif' : '✗ Pasif'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/urunler/' + u.id)}>Düzenle</button>
                        <button className="btn btn-danger btn-sm" onClick={() => handleSil(u.id)}>Sil</button>
                      </div>
                    </td>
                  </tr>
                ))
              ];
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
